/**
 * The tier-flip history, in words — shared by the page registry and the page budget, which both
 * show the last flips. Its own module because the budget screen already imports the registry's
 * tier names, and a second import the other way would be a cycle.
 */
import type { SeoBudget } from '../lib/api/hooks/seo';

export const REBALANCED = 'page_registry.tiers_rebalanced';

type Flip = SeoBudget['flips'][number];

/**
 * One line per flip. A nightly run records the ids it promoted and demoted and the room either
 * side; a manual flip records what changed of the row's tier and pin.
 */
export function describeFlip(f: Flip): string {
  const after = f.after ?? {};
  const before = f.before ?? {};
  if (f.action === REBALANCED) {
    const count = (v: unknown) => (Array.isArray(v) ? v.length : 0);
    return `${count(after.promoted)} promoted · ${count(after.demoted)} demoted · room ${String(before.room ?? '—')} → ${String(after.room ?? '—')}`;
  }
  // The audit log keeps only the fields that changed, so a pin-only flip carries no tier at all.
  const hasTier = 'generation_tier' in before || 'generation_tier' in after;
  const tier = !hasTier
    ? ''
    : before.generation_tier === after.generation_tier
      ? String(after.generation_tier)
      : `${String(before.generation_tier ?? '—')} → ${String(after.generation_tier ?? '—')}`;
  const pin = before.tier_locked === after.tier_locked ? '' : after.tier_locked ? 'pinned' : 'unpinned';
  return [after.path ? String(after.path) : '', tier, pin].filter(Boolean).join(' · ') || '—';
}

